import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';

import FormResourceUtil from '../../utils/FormResourceUtil';
import CommandActions from '../../actions/CommandActions';
import CommandHelper from '../../remote/CommandHelper';
import ServiceHelper from '../../remote/ServiceHelper';
import CommandResolver from '../../utils/CommandResolver';
import Command from '../../remote/Command';
import Fade from '../../utils/Fade';
import AuthorityUtil from '../../utils/AuthorityUtil';
import Warn from '../../utils/Warn';
require('./style/Attachment.css');

class Attachment extends React.Component
{

	constructor(props)
	{
		super(props);
		this.resourceURL=window.parent.window.userInfos.resourceURL;
		this.serviceURL=window.parent.window.userInfos.serviceURL;
		var btnState={
			upload:true,
			download:true,
			delete:true,
			rename:true,
			open:true
		}
		this.state={
			tableId:this.props.tableId,
			recId:this.props.recId,
			formId:this.props.formId,
			aukey:this.props.aukey,
			btnState:btnState,
			fileList:[],
			selectedIndex:'0',
			renameIsShow:false,
			coverIsShow:false
		}


	}
	
	closeAttachmentHandler()
	{

		//关掉要卸载
		let $reactComponentContainer = $("#attachmentModal .modal");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		$reactComponentContainer.remove();
	}

	componentDidMount(){
		$("#attachmentModal .modal").children(':first').draggable({ cursor: "move",containment: "parent" });
		
		this.doRefresh();		
		
	}

	doRefreshButton()
	{
		//3_50000004.3
		let xmlType2SCache = AuthorityUtil.xmlType2SCache;
		if(xmlType2SCache && xmlType2SCache.hasOwnProperty(window.menuItemId))
		{
			xmlType2SCache = xmlType2SCache[window.menuItemId];
			if(xmlType2SCache && xmlType2SCache.hasOwnProperty(this.props.aukey))
			{
				let auNode = xmlType2SCache[this.props.aukey];
				if(auNode)
				{
					let btnState={
						upload:(auNode.visible+'')=="true"?true:false,
						download:(auNode.query+'')=="true"?true:false,
						delete:(auNode.exp+'')=="true"?true:false,
						rename:(auNode.edit+'')=="true"?true:false,
						open:(auNode.save+'')=="true"?true:false
					};
					let currentWin;
					try {
						currentWin = window.getCurrentWin();
					} catch (error) {
						currentWin = window.parent.getCurrentWin();
					}
					let formModule = currentWin.formModuleInstance;
					if(formModule)
					{
						if(btnState.upload == true && formModule.dsAttachmentAu.hasOwnProperty("upload"))
						{
							btnState.upload = formModule.dsAttachmentAu["upload"];
						}
						if(btnState.rename == true && formModule.dsAttachmentAu.hasOwnProperty("rename"))
						{
							btnState.rename = formModule.dsAttachmentAu["rename"];
						}
						if(btnState.delete == true && formModule.dsAttachmentAu.hasOwnProperty("del"))
						{
							btnState.delete = formModule.dsAttachmentAu["del"];
						}
					}
					

					this.setState({btnState:btnState});
				}
			}
			
		}
		
		/*var xml:XML = ClientSessionAuthority.getXmlType2SCacheItemByKey(aukey);
		if(xml != null)
		{
			btnUpLoad.enabled = String(xml.@visible) == "true"?true:false;
			btnDownLoad.enabled = String(xml.@query) == "true"?true:false;
			btnDelete.enabled = String(xml.@export) == "true"?true:false;
			btnRename.enabled = String(xml.@edit) == "true"?true:false;
			btnOpenFile.enabled = String(xml.@save) == "true"?true:false;
		}
		else
		{
			btnUpLoad.enabled = true;
			btnDownLoad.enabled = true;
			btnDelete.enabled = true;
			btnRename.enabled = true;
			btnOpenFile.enabled = true;
		}*/
	}

	doRefresh(){
		// if(btnUpLoad == null){上传为null
		// 	callLater(doRefreshButton,[aukey]);	
		// }else{
		// 	doRefreshButton(aukey);
		// }

		this.doRefreshButton();

		var tableId = this.state.tableId;
				
		var recId = this.state.recId;
				
		if(tableId==null || recId==null)
		{
			var title = "附件：";
			this.setState({
				fileList:[]
			});
		}
		else
		{
			var title = "附件:"+tableId+"/"+recId;

			// if(lb!=null)
			// 	lb.text = "";????

			var command = Command.createService( 
				"gongqi.erp.gotmodel.services.AttachmentService", 
				"listAttachments", 
				"List"
			);
			command.appendArg(tableId+"/"+recId	);
			var that=this;
			var remoteArg = {command:command,resultFunction:this.rpc_result_getAttachmentHandler.bind(this),sync:false};
			ServiceHelper.addTokenWithCommand(remoteArg);
		}
	}

	rpc_result_getAttachmentHandler(data){
		this.setState({
			fileList:data.result
		});
		$(this.attachMentComponentTB).viewer({
			fullscreen:false
		});
	}

	btnUpLoad_clickHandler(){
		if(this.state.btnState.upload == false)
			return;
		$(this.uploaderInput).click();
	}

	preventDe(e)
	{
		e.preventDefault();
	}

	onDragLeaveHandler(e)
	{
		e.preventDefault();
		$(this.uploadPrompt).html("上传");
	}

	onDragOverHandler(e)
	{
		e.preventDefault();
		$(this.uploadPrompt).html("松开鼠标上传");
	}

	onDragEnterHandler(e)
	{
		e.preventDefault();
		$(this.uploadPrompt).html("松开鼠标上传");
	}

	onDragDrop(e)
	{
		e.preventDefault();
		var uploadFiles = e.target.files || e.dataTransfer.files;
		this.fileSelectedHandler(uploadFiles);
	}

	upLoaderChangeHandler(e){
		var uploadFiles = e.target.files || e.dataTransfer.files;
        //var uploadFile = uploadFiles[0];
		this.fileSelectedHandler(uploadFiles);
	}


	doFileSelected(uploadFiles){
		var fileList=this.state.fileList;
		var fileName=uploadFiles[0].name;
		this.uploadFiles=uploadFiles;
		if(fileList.length>0&&fileList.indexOf(fileName)>-1){
			this.setState({coverIsShow:true});
			
		}else{
			this.upLoadFileHandler();
		}
	}

	changeUploadFileName(file){
		var uploadFile=this.uploadFiles[0];

		var type=uploadFile.type;
		
		//上传的时候重名，更改名字
		var fileName=uploadFile.name;
		var fileList=this.state.fileList;
		if(fileName.lastIndexOf('.')!=-1){
			fileName=fileName.substring(0,fileName.lastIndexOf("."))+"(1)"+fileName.substr(fileName.lastIndexOf("."))
		}else{
			fileName = fileName+"(1)";
		}
		while (fileList.length>0&& fileList.indexOf(fileName)!=-1){
			if(fileName.lastIndexOf(".") != -1){
				fileName = fileName.substring(0,fileName.lastIndexOf("."))+"(1)"+fileName.substr(fileName.lastIndexOf("."));
			}else{
				fileName = fileName+"(1)";
			}
		}
		var finalFile= new File([uploadFile],fileName,{type:type});
		//this.uploadFiles[0]=finalFile;
		this.reNameUploadFile = finalFile;
		this.upLoadFileHandler();
	}

	upLoadFileHandler()
	{
		var uploadFiles=this.uploadFiles;
		var fileNames = [];
		for(let i = 0;i<uploadFiles.length;i++)
		{
			let upLoadFile = uploadFiles[i];
			if(i == 0 && this.reNameUploadFile)
			{
				upLoadFile = this.reNameUploadFile;
				this.reNameUploadFile = null;
			}
			fileNames.push(upLoadFile.name);
		}
		this.setState({coverIsShow:false});
		
		var tableId=this.state.tableId;
		var recId=this.state.recId;
		var path ="attachments/"+tableId+"/"+recId+"/"+fileNames[0];
		var serviceURL=this.serviceURL;
		var url=serviceURL+ "/FileUpLoad?path="+encodeURIComponent(path);


		var domain = window.didomain;
		try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
		{
			if(!domain && window.parent && window.parent.window)
				domain = window.parent.window.didomain;

			if(domain)
			{
				var loginToken = window.loginToken;
	  			var loginDataArea = window.loginDataArea;
				if(window.parent && window.parent.window)
				{
					if(!loginToken)loginToken = window.parent.window.loginToken;
					if(!loginDataArea)loginDataArea = window.parent.window.loginDataArea;
				}
				if(!loginToken)
					url+=("&token="+localStorage.getItem("userToken"));
			}
				
		}
		catch(e)
		{
			
		}

		var oMyForm = new FormData();    
		//oMyForm.append("path",path);
		for(let i = 0;i<uploadFiles.length;i++)
		{
			let uploadFile = uploadFiles[i];
			oMyForm.append("file"+i,uploadFile);
		}
		
        this.client=new XMLHttpRequest();
        var progressBar=$('<progress></progress>').css({'width':'15em','height':'2.1em'}).html('您的浏览器不支持progress元素');
        var that=this;
        var progressA=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
        var progressBtn=$('<div></div>').append(progressA);
        var progressDiv=$('<div></div>').css({'position':'absolute','top':'40.5%','left':'40%','display':'flex'}).append(progressBar).append(progressBtn);
        var percentageDiv=$('<span></span>');
        var time=$("<span></span>");
        var percentDiv=$('<div></div>').css({'position':'absolute','top':'41%','left':'40.5%','font-size':'0.8em'}).append(percentageDiv).append(time);
        var progressBorder=$("<div></div>").append(progressDiv).append(percentDiv).attr('id','progressBorder').addClass('modal');
        $('body').append(progressBorder);
        
        this.client.upload.onprogress = function(pe) {
        	
	        if(pe.lengthComputable) {
	        	progressBorder.css('display','block');
	         	progressBar.attr('max',pe.total);
	        	progressBar.attr('value',pe.loaded);
	         	percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
	        }
	        var nt = new Date().getTime();//获取当前时间
	        var pertime = (nt-this.ot)/1000; //计算出上次调用该方法时到现在的时间差，单位为s
	        this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
	        var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
	        this.oloaded = pe.loaded;//重新赋值已上传文件大小，用以下次计算
	                    
	        //上传速度计算
	        var speed = perload/pertime;//单位b/s
	        var bspeed = speed;
	        var units = 'b/s';//单位名称
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'k/s';
	        }
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'M/s';
	        }
	        speed = speed.toFixed(1);
                        //剩余时间
        	var resttime = ((pe.total-pe.loaded)/bspeed).toFixed(1);
	        
	        var timeContent=' '+speed+units+'，剩余时间：'+resttime+'s';
	        time.html(timeContent); 
	    }

	    this.client.upload.onloadstart = function(){//上传开始执行方法
	        this.ot = new Date().getTime();   //设置上传开始时间
	        this.oloaded = 0;//设置上传开始时，以上传的文件大小为0
	    };
	    this.client.onreadystatechange=this.uploadStateChangeHandler.bind(this,fileNames);
	                
	    this.client.open("POST", url,true);//+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
	    this.client.withCredentials = true;
	               
	    this.client.onloadend = function(pe) {
	            // document.getElementById('progressDiv').style.display='none';
			$('#progressBorder').remove();
	        
	    }
	    this.client.send(oMyForm);
	}

	uploadStateChangeHandler(fileNames)
	{
		var that=this;
		if (this.client.readyState==4)
	    {// 4 = "loaded"
	  		if (this.client.status==200)
	    	{	
	    		var options={
	    			state:'success',
	    			text:'上传成功！'
	    		}
				Fade.show(options);
				window.afterAttachment({
					methodName:"doAttachmentUpload",
					methodArgs:[{value:fileNames.join(),type:"String"}],
					methodName2:"attachmentUpload"
				});
	    		//更新列表
	    		//this.doRefresh();
				var fileList=this.state.fileList;
				let fileListChanged = false;
				for(let i = 0;i<fileNames.length;i++)
				{
					let fileName = fileNames[i];
					if(fileList.indexOf(fileName)==-1){
						fileList.push(fileName);
						fileListChanged = true;
					}
				}
				if(fileListChanged == true)
					this.setState({fileList:fileList});

	    		/*if(fileList.indexOf(fileName)==-1){
	    			fileList.push(fileName);
	    			this.setState({fileList:fileList});
	    		}*/
	    		var _parentWindow = window.parent.window;
			  	if(_parentWindow)
			  	{
				    _parentWindow.updateAttachmentNum(fileList.length);
				}
				window.updateAttachmentNum(fileList.length);
	    	}
		  	else
		    {
		    	var options={
		    		state:'error',
	    			text:'上传失败！'
	    		}
	    		Fade.show(options);
		    }
	  	}	
	  	$(this.uploaderInput).val('');
	}

	upLoadCancelHandler(){
		//取消上传
		//上传过程中取消上传
		//重名 直接取消上传
		//this.client.abort();
		if(this.client){
			this.client.abort();
		}else{
			this.setState({
				coverIsShow:false
			});
		}
		$(this.uploaderInput).val('');
		
	}

	fileSelectedHandler(uploadFiles){
		
		for(let i = 0;i<uploadFiles.length;i++)
		{
			let uploadFile = uploadFiles[i];
			if(uploadFile.size > 500*1024*1024)
			{
				var options={
					text:'要上传的文件不允许超过500M'
				}
				Fade.show(options);
				return;
			}
		}
		this.doFileSelected(uploadFiles);
	}



	btnDownLoad_clickHandler(){
		//下载
		if(this.state.btnState.download == false)
			return;

		var selectedIndex=this.state.selectedIndex;
		var fileList=this.state.fileList;
		var selectedItem=fileList[selectedIndex];
		if(selectedItem == null || selectedItem == "")
			return;
		var base=this.resourceURL;
		var tableId=this.state.tableId;
		var recId=this.state.recId;
		var url=base+"/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(selectedItem);
		var domain = window.didomain;
		try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
		{
			if(!domain && window.parent && window.parent.window)
				domain = window.parent.window.didomain;

			if(domain)
			{
				var loginToken = window.loginToken;
	  			var loginDataArea = window.loginDataArea;
				if(window.parent && window.parent.window)
				{
					if(!loginToken)loginToken = window.parent.window.loginToken;
					if(!loginDataArea)loginDataArea = window.parent.window.loginDataArea;
				}
				if(!loginToken)
					url+=("?token="+localStorage.getItem("userToken"));
			}
				
		}
		catch(e)
		{
			
		}
		
		// /GongqiERP/resource/attachments/30102106/1993897950/loading.gif
		// var url='http://www.gongqi.info:10208/bin/'+selectedItem;
		if(typeof url == 'object' && url instanceof Blob)
		{
			url = URL.createObjectURL(url); // 创建blob地址
		}
	    var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
	    a.href = url;
	    a.download = selectedItem;
	   
	    var e = document.createEvent('MouseEvents');
	    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	    a.dispatchEvent(e);
	    URL.revokeObjectURL(url);

	}
	btnDownLoad_AllAttachments(){
				//下载
				if(this.state.btnState.download == false)
				return;
	
			var selectedIndex=this.state.selectedIndex;
			var fileList=this.state.fileList;
			for(let i in fileList){
				var selectedItem=fileList[i];
				if(selectedItem == null || selectedItem == "")
					return;
				var base=this.resourceURL;
				var tableId=this.state.tableId;
				var recId=this.state.recId;
				var url=base+"/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(selectedItem);
				var domain = window.didomain;
				try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
				{
					if(!domain && window.parent && window.parent.window)
						domain = window.parent.window.didomain;
		
					if(domain)
					{
						var loginToken = window.loginToken;
						  var loginDataArea = window.loginDataArea;
						if(window.parent && window.parent.window)
						{
							if(!loginToken)loginToken = window.parent.window.loginToken;
							if(!loginDataArea)loginDataArea = window.parent.window.loginDataArea;
						}
						if(!loginToken)
							url+=("?token="+localStorage.getItem("userToken"));
					}
						
				}
				catch(e)
				{
					
				}
				
				// /GongqiERP/resource/attachments/30102106/1993897950/loading.gif
				// var url='http://www.gongqi.info:10208/bin/'+selectedItem;
				if(typeof url == 'object' && url instanceof Blob)
				{
					url = URL.createObjectURL(url); // 创建blob地址
				}
				var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
				a.href = url;
				a.download = selectedItem;
			   
				var e = document.createEvent('MouseEvents');
				e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
				a.dispatchEvent(e);
				URL.revokeObjectURL(url);

			}
	}

	
	btnDelete_clickHandler(){
		if(this.state.btnState.delete == false)
			return;
		if(!this.state.fileList || this.state.fileList.length==0)
			return;
		var that = this;
		Warn.show({text:"确定要删除该附件吗？",state:"warn",
			confirm:
			{
				isShow:true,
				event:function()
				{
					that.doDeleteAttachment();
				}
			},

			cancel:
			{
				isShow:true
			}
		});

	}

	doDeleteAttachment()
	{
		//删除
		var selectedIndex=this.state.selectedIndex;
		var fileList=this.state.fileList;
		var selectedItem=fileList[selectedIndex];
		if(selectedItem != null && selectedItem != ""){
			var command = Command.createService(
				"gongqi.erp.gotmodel.services.AttachmentService", 
				"deleteFile", 
				"boolean"
			);
			var tableId=this.state.tableId;
			var recId=this.state.recId;
			command.appendArg("attachments/"+tableId+"/"+recId+"/"+selectedItem);
			var that=this;
			var remoteArg = {command:command,resultFunction:function(data){that.rpc_result_DeleteHandler(data,selectedIndex);},sync:false};
			ServiceHelper.addTokenWithCommand(remoteArg);
		}
	}

	rpc_result_DeleteHandler(data,selectedIndex){
		if(data.result){
			var fileList=this.state.fileList;
			var file = fileList.splice(selectedIndex,1);
			this.setState({fileList:fileList});
			var _parentWindow = window.parent.window;
		  	if(_parentWindow)
		  	{
				_parentWindow.updateAttachmentNum(fileList.length);
				window.updateAttachmentNum(fileList.length);
				if(Array.isArray(file))
				{
					file = file.join();
				}
				
				window.afterAttachment({
					methodName:"doAttachmentDelete",methodArgs:[{value:file,type:"String"}],
					argInfoMethod:"attachmentDelete",
					methodName2:"attachmentDelete"
				});

		  	}
		}else{
			var options={
				text:'删除失败'
			}
			Fade.show(options);
		}
	}

	btnRename_clickHandler(){
		if(this.state.btnState.rename == false)
			return;
		//重命名
		var selectedIndex=this.state.selectedIndex;
		var fileList=this.state.fileList;
		var selectedItem=fileList[selectedIndex];

		if(selectedItem!=null){
			this.setState({
				renameIsShow:true
			});
			var fileList=this.state.fileList;
			var selectedItem=fileList[selectedIndex];
			$(this.renameInput).val(selectedItem);
			$(this.renameInput).select();
		}

	}

	doRename(){
		var selectedIndex=this.state.selectedIndex;
		var fileList=this.state.fileList;
		var selectedItem=fileList[selectedIndex];
		if(selectedItem != null&& selectedItem != ""){
			var command = Command.createService( 
				"gongqi.erp.gotmodel.services.AttachmentService", 
				"renameFile", 
				"boolean"
			);
			var tableId=this.state.tableId;
			var recId=this.state.recId;
			var name=$(this.renameInput).val();
			command.appendArg("attachments/"+tableId+"/"+recId+"/"+selectedItem);
			command.appendArg(name);
			var that=this;
			var remoteArg = {command:command,resultFunction:function(data){that.rpc_result_RenameHandler(data,name,selectedIndex);},sync:false};
			ServiceHelper.addTokenWithCommand(remoteArg);
		}
	}



	rpc_result_RenameHandler(data,name,selectedIndex){
		if(data.result){
			var fileList=this.state.fileList;
			var origName = fileList[selectedIndex];
			fileList[selectedIndex]=name;

			window.afterAttachment({
					methodName:"doAttachmentRename",
					methodArgs:[{value:origName,type:"String"},{value:name,type:"String"}],
					methodName2:"attachmentRename"
			});

		}else{
			var options={
				text:'操作失败'
			}
			Fade.show(options);
		}
		this.setState({
			renameIsShow:false
		});
		$(this.renameInput).val('');
	}

	cancelRename(){
		this.setState({
			renameIsShow:false
		});
		$(this.renameInput).val('');
	}

	cancelRename2()
	{
		this.setState({
			coverIsShow:false
		});
		$(this.renameInput).val('');
		$(this.uploaderInput).val('');
	}

	//打开
	btnOpenFile_clickHandler(){

		if(this.state.btnState.open == false)
			return;

		var selectedIndex=this.state.selectedIndex;
		var fileList=this.state.fileList;
		var selectedItem=fileList[selectedIndex];
		if(selectedItem == null)
			return;
		
		var tableId=this.state.tableId;
		var recId=this.state.recId;
		var base=this.resourceURL;


		var url=base+"/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(selectedItem);

		window.open(url);
	}

	getFileTypeIcon(fileType,dataOriginal = null)
	{
		if(!fileType)
		{
			return <div style={{background:'url(images/doccopy.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		if(fileType.indexOf("xls") != -1)
		{
			return <div style={{background:'url(images/xls.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		else if(fileType.indexOf("pdf") != -1)
		{
			return <div style={{background:'url(images/pdf.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		else if(fileType.indexOf("ppt") != -1)
		{
			return <div style={{background:'url(images/ppt.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		else if(fileType.indexOf("doc") != -1)
		{
			return <div style={{background:'url(images/doc.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		else if(fileType.indexOf(".png") !=-1 || fileType=="png")
		{
			// let src = 'images/jpg.png';
			return <img data-original={dataOriginal}   src={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></img>
			// return <div data-original={dataOriginal} style={{background:'url(images/png.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		else if(fileType == "jpg" || fileType.indexOf(".jpg") != -1)
		{
			return <img data-original={dataOriginal} src={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></img>
			// return <div data-original={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		} 
		else if(fileType == "bpm")
		{
			return <div style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		else if(fileType.indexOf("txt") != -1)
		{
			return <div style={{background:'url(images/txt.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
		else
		{
			return <div style={{background:'url(images/doccopy.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
		}
	}

	getTableContent(){
		var fileList=this.state.fileList;
		var tableContent=[];
		var that=this;
		var selectedIndex=this.state.selectedIndex;
		if(fileList.length==0){

		}else{
			for(var i=0;i<fileList.length;i++){
				var fileName=fileList[i];
				if(i==selectedIndex)
				{
					let fileType;
					if(fileName)
					{
						fileType = fileName.substr(fileName.indexOf(".")+1,fileType);
					}
					var tableId=this.state.tableId;
					var recId=this.state.recId;
					var base=this.resourceURL;
					var dataOriginal=base+"/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(fileList[i]);
					let fileTypeIcon = this.getFileTypeIcon(fileType,dataOriginal);

					tableContent.push(
						<tr onClick={that.selectedChange.bind(this,i)} key={i} className='selectedFile'>
							<th style={{paddingTop:'10px',paddingBottom:'10px',fontFamily:'PingFang-SC-Regular',
								fontSize:'14px',color:'#000000',fontWeight:'normal',display:'flex',alignItems:'center',borderTop: 'none',
								borderBottom:'1px solid rgba(0,0,0,0.10)'}}>
								{fileTypeIcon}
								<div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>{fileName}</div>
							</th>
						</tr>
					);
				}
				else
				{
					let fileType;
					if(fileName)
					{
						fileType = fileName.substr(fileName.indexOf(".")+1,fileType);
					}
					var tableId=this.state.tableId;
					var recId=this.state.recId;
					var base=this.resourceURL;
					var dataOriginal=base+"/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(fileList[i]);
					let fileTypeIcon = this.getFileTypeIcon(fileType,dataOriginal);
					tableContent.push(
						<tr onClick={that.selectedChange.bind(this,i)} key={i}>
							<th style={{paddingTop:'10px',paddingBottom:'10px',fontFamily:'PingFang-SC-Regular',fontSize:'14px',
								color:'#000000',fontWeight:'normal',display:'flex',alignItems:'center',borderTop: 'none',
								borderBottom:'1px solid rgba(0,0,0,0.10)'
								}}>
								{fileTypeIcon}
								<div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>{fileName}</div>
							</th>
						</tr>
					);
				}
				
			}
		}
		return tableContent;
	}

	selectedChange(index){
		console.log(index);
		this.setState({
			selectedIndex:index
		})
	}

	render()
	{
		
		let _style = {display:"flex",backgroundColor:"#ffffff",flexDirection:"column",flexGrow:'1',overflow:'auto'};
		let _className;
		let btnState=this.state.btnState;


		let uploadColor = btnState['upload'] == true?"#0178D4":"#919191";
		let downloadColor = btnState['download'] == true?"#4A90E2":"#919191";
		let deleteColor = btnState['delete'] == true?"#F84F59":"#919191";
		let renameColor = btnState['rename'] == true?"#F5A623":"#919191";
		let openColor = btnState['open'] == true?"#1AA95E":"#919191";

		
		let btnStyle={alignSelf :'stretch',padding:'1px 6px', margin:'3px'};
		let renameIsShow=this.state.renameIsShow;
		let coverIsShow=this.state.coverIsShow;
		var tableContent=this.getTableContent();
		
		return	(<div style={{alignSelf:"center",display:'flex',flexFlow:'column',background:"#ffffff",background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px',width:'508px',height:'399px'}}>
	              <div className="modal-header" style={{position:"relative"}}>
				  	<div className="modal-close" onClick={this.closeAttachmentHandler.bind(this)}></div>
	                <h5 className="modal-title">附件</h5>
	              </div>
				  <div style={{cursor:'pointer',height:'55px',margin:'12px',background:'#FFFFFF',border:'1px dashed #E0E0E0',borderRadius:'6px',display:'flex',alignItems:'center',flexDirection:'column',justifyContent:'center'}}
				  	onClick={this.btnUpLoad_clickHandler.bind(this)} onDrop={this.onDragDrop.bind(this)} onDragLeave={this.onDragLeaveHandler.bind(this)} onDragOver={this.onDragOverHandler.bind(this)} onDragEnter={this.onDragEnterHandler.bind(this)}
				  >
				  	<i className = "fa fa-cloud-upload" style={{color:uploadColor,fontSize:'22px'}}></i>
					<div ref={node=>this.uploadPrompt = node} style={{color:uploadColor,fontFamily:'PingFang-SC-Bold',fontSize:'14px'}}>上传</div>
				  </div>
	              <div ref={node => this.attachMentComponent = node} style={_style} className={_className}>
	               	<div style={{overflowY: 'auto',minWidth:'400px',paddingLeft:'10px',paddingRight:'10px',flexGrow:'1'}}>
	               		<table className="table table-condensed" ref={node => this.attachMentComponentTB = node}>
	               			<tbody>{tableContent}</tbody>
	               		</table>
	               	</div>
	               	<div style={{display:"flex",flexDirection:"row",justifyContent:"flex-end",paddingTop:'14px',paddingBottom:'10px',borderTop:'1px solid rgba(0,0,0,0.10)'}}>
	               		<input type="file" accept="*" multiple="true"  style={{display:'none'}} ref={node => this.uploaderInput = node} onChange={this.upLoaderChangeHandler.bind(this)}/>
	               		
						{/* <div onClick={this.btnDownLoad_AllAttachments.bind(this)} style={{display:'flex',fontFamily:'PingFang-SC-Regular',fontSize:'14px',color:downloadColor,alignItems:'center',paddingRight:'15px',cursor:'pointer'}}>
							<i className="fa fa-cloud-download" style={{color:downloadColor,fontSize:'17px',paddingRight:'5px',marginBottom:'1px'}}></i>全部下载
						</div> */}
						<div onClick={this.btnDownLoad_clickHandler.bind(this)} style={{display:'flex',fontFamily:'PingFang-SC-Regular',fontSize:'14px',color:downloadColor,alignItems:'center',paddingRight:'15px',cursor:'pointer'}}>
							<i className="fa fa-cloud-download" style={{color:downloadColor,fontSize:'17px',paddingRight:'5px',marginBottom:'1px'}}></i>下载
						</div>
						<div onClick={this.btnDelete_clickHandler.bind(this)} style={{display:'flex',fontFamily:'PingFang-SC-Regular',fontSize:'14px',color:deleteColor,alignItems:'center',paddingRight:'15px',cursor:'pointer'}}>
							<i className="fa fa-trash-o" style={{color:deleteColor,fontSize:'17px',paddingRight:'5px',marginBottom:'1px'}}></i>删除
						</div>
						<div onClick={this.btnRename_clickHandler.bind(this)} style={{display:'flex',fontFamily:'PingFang-SC-Regular',fontSize:'14px',color:renameColor,alignItems:'center',paddingRight:'15px',cursor:'pointer'}}>
							<i className="fa fa-pencil-square-o" style={{color:renameColor,fontSize:'17px',paddingRight:'5px',marginBottom:'1px'}} aria-hidden="true"></i>重命名
						</div>
						<div onClick={this.btnOpenFile_clickHandler.bind(this)} style={{display:'flex',fontFamily:'PingFang-SC-Regular',fontSize:'14px',color:openColor,alignItems:'center',paddingRight:'15px',cursor:'pointer'}}>
							<i className="fa fa-folder-open-o" style={{color:openColor,fontSize:'17px',paddingRight:'5px',marginBottom:'1px'}} aria-hidden="true"></i>打开
						</div>              		
	               	</div>
	              </div>
	              <div hidden={!renameIsShow} style={{position: 'absolute',top: '45%',border: '2px solid rgb(229, 229, 229)',left: '42%'}}>
	              	<div className="modal-header" style={{background:"#ffffff",padding:"5px",position:"relative"}}>
		              	<i className="fa fa-close" style={{position:"absolute",top:"7px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.cancelRename.bind(this)}></i>
		                <h5 className="modal-title">重命名</h5>
		             </div>
		             <div style={_style} className={_className}>
		             	<label>新名字<i className="fa fa-snowflake-o" style={{fontSize: '8px', color: 'red'}}></i></label>
		             	<input spellCheck="false" style={{minWidth:'200px'}} ref={node => this.renameInput = node}/>

		             </div>
		             <div  style={{display:"flex",padding:"10px",backgroundColor:"#ffffff",flexDirection:"row",justifyContent:"flex-end"}} className={_className}>
		             	<button type="button" className="btn btn-info" style={btnStyle} onClick={this.doRename.bind(this)}>确定</button>
	               		<button type="button" className="btn btn-info" style={btnStyle} onClick={this.cancelRename.bind(this)}>取消</button>
		             </div>

	              </div>
	              <div hidden={!coverIsShow} style={{position: 'absolute',top: '45%',border: '2px solid rgb(229, 229, 229)',left: '42%'}}>
	              	<div className="modal-header" style={{background:"#ffffff",padding:"5px",position:"relative"}}>
		              	<i className="fa fa-close" style={{position:"absolute",top:"7px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.cancelRename2.bind(this)}></i>
		                <h5 className="modal-title">提示</h5>
		             </div>
		             <div style={_style} className={_className}>
		             	已上传过同样文件名的文件

		             </div>
		             <div style={{display:"flex",padding:"10px",backgroundColor:"#ffffff",flexDirection:"row",justifyContent:"flex-end"}} className={_className}>
		             	<button type="button" className="btn btn-info" style={btnStyle} onClick={this.upLoadFileHandler.bind(this)}>覆盖</button>
		             	<button type="button" className="btn btn-info" style={btnStyle} onClick={this.changeUploadFileName.bind(this)}>重命名</button>
	               		<button type="button" className="btn btn-info" style={btnStyle} onClick={this.cancelRename2.bind(this)}>取消</button>
		             </div>

	              </div>
	            </div>);
	}
};

Attachment.defaultProps = {
};

export default Attachment;



// WEBPACK FOOTER //
// ./src/components/attachment/Attachment.js